const UA = navigator.userAgent;
const _isAndroid = UA.indexOf("Android") >= 0;
const _isAphone = _isAndroid && UA.indexOf("Mobile") >= 0;
let _imgUrl;
let dpr = window.devicePixelRatio;

/**
 * 设计提供的规范是基于160dpi下的尺寸
 */
let size = {
  vft_regular: 375,
  vft_large: 667,
  vft_huge: 980,
  vft_max: 1366,
};

export function setSize(imgUrl) {
  const screenWidth = document.documentElement.clientWidth;
  _imgUrl = imgUrl;
  let dpi; //就是我们通常所讲的倍数，例如拿到的dpr=2，那dpi=2，表示是两倍屏。有些安卓机的dpr=1.5，但确实也是要按2倍屏来做，所以dpi也会=2。
  if (dpr > 1 && dpr < 3) {
    dpi = 2;
  } else if (dpr >= 3) {
    dpi = 3;
  } else if (dpr <= 1) {
    dpi = 1;
  } else {
    dpi = 2;
  }
  /*
        2020.5.12
        普通屏幕是160ppi，也就是我们常说的1倍屏幕。
        如果是320ppi，也就是我们常说的2倍屏幕。
        现在所有的设备都是160ppi+，高清的iphone XM 就是458ppi，虽然dpr是3，但其实是不够3倍屏的，所以还是以2倍屏来处理。
        2020.5.26
        有某些特殊的安卓机型dpr居然是4，所以有了以下判断，
    */
  if ((dpr >= 4) & _isAphone) {
    dpr = 2;
    dpi = 2;
  }
  let index =
    Object.values(size).findIndex((el) => el > (dpr * screenWidth) / dpi) - 1;
  if (index == -1) {
    index = 0;
  } else if (index == -2) {
    index = Object.values(size).length - 1;
  }

  document.documentElement.classList.remove(
    "vft_regular",
    "vft_large",
    "vft_huge",
    "vft_max"
  );
  document.documentElement.classList.add(Object.keys(size)[index]);

  if (imgUrl && index > 0) {
    setUniverseBg(_imgUrl);
  }
  return Object.keys(size)[index];
}

/**
 * 设置宇宙版背景图，一般情况下设计提供一张2732*808的图，折叠屏尺寸下，背景图为原图的70%，大于折叠屏后，两边留白
 * @param {*} imgUrl
 */
function setUniverseBg(imgUrl) {
  document.documentElement.classList.add("simple_fit");
  if (imgUrl.indexOf("simple_fit") < 0) {
    let UniverseBgDiv = document.createElement("div");
    UniverseBgDiv.className = "universe_bg";
    UniverseBgDiv.innerHTML = `<img class="universe_bg_img" src=${imgUrl}>`;
    document.body.appendChild(UniverseBgDiv);
  }
}

window.addEventListener("resize", function () {
  document.documentElement.classList.remove("simple_fit");
  let el = document.querySelector(".universe_bg");
  if (el) el.remove();
  setSize(_imgUrl);
});
